// Module-level, never defined inside a render body.
// AI-CONTEXT: See docs/pitfalls.md#state-component-defined-in-render

/**
 * The up/down arrow in a sortable column header.
 *
 * Drawn as SVG rather than as ▲/▼ glyphs: at this size the glyphs carry so
 * much built-in padding that the two triangles touch and read as one diamond.
 *
 * Both arrows are always drawn and the active direction is highlighted, so the
 * control keeps the same width whether or not the column is sorted and the
 * header never shifts.
 *
 * @param {object} props
 * @param {'asc'|'desc'|null} [props.direction] - Active direction, or null when this column is not sorted
 */
const TableSortIcon = ({ direction = null }) => (
  <svg
    className="common-table__sort-icon"
    viewBox="0 0 8 12"
    width="8"
    height="12"
    aria-hidden="true"
    focusable="false"
  >
    <polygon
      className={[
        'common-table__sort-arrow',
        direction === 'asc' ? 'common-table__sort-arrow--active' : '',
      ].filter(Boolean).join(' ')}
      points="4,0 8,4.5 0,4.5"
    />
    <polygon
      className={[
        'common-table__sort-arrow',
        direction === 'desc' ? 'common-table__sort-arrow--active' : '',
      ].filter(Boolean).join(' ')}
      points="4,12 8,7.5 0,7.5"
    />
  </svg>
);

export default TableSortIcon;
